export const laws = {
  en: `1. Name of business:
TODOROKI Inc.
2. Name of representative or person in charge of the business:
Inoue Masaya

3. Address:
Marubashi Building 4F, 25-2 Higashi 1-chome, Shibuya-ku, Tokyo

4. Phone number:
050-5896-3123

5. Email address:
support@art-scenes.net

6. Product sales price/service fees:
Prices are displayed for products on sale.
Please refer to the purchase page for each product/service.

7. Costs required additional to the price:
Prices are displayed without including the shipping fees, and shipping fees must be paid upon delivery.
We will contact you about shipping fees after your order or inquiry.
If you are not satisfied with the shipping fees and refuse to pay them, your order will be canceled, and payment/shipping will not be made even if you have already placed an order.
Please note that shipping fees cannot be calculated automatically for all artworks, as the shipping fees vary according to the dimensions of the artwork, the way it is packaged and the fluctuation of insurance premiums, we will thus have to calculate shipping fees manually.

In the case of a payment via bank transfer, the customer will be responsible for any additional fees from the bank.
If the purchase and shipping generate additional taxes, including customs duties and VAT, they will be borne by the customer.
Freight charges incurred after the package reaches the customer's designated delivery address, transportation costs incurred for picking up the package, and other expenses will be the financial responsibility of the customer.
Customers will be responsible for all internet connection fees and communication fees required for browsing the pages of this website, purchasing content, downloading software, etc.

8. Payment period:

Bank transfer: In principle, payment should be made to the specified account within 3 days after the order is confirmed. However, in special circumstances, such as in the occurrence of a purchase during an art fair, we will indicate the payment period on the product or contact you.
Credit card: the payment will take place in accordance with the customer’s contract with the card company used.

9. Accepted payment method:
•	Credit card payment
•	Bank transfer
•	For other high-priced products, the product provider will inform you of other possible payment methods.

10. Delivery period or service provision:

For bank transfer, the product provider will ship the product within 10 business days after payment is confirmed.
For card payment, the product provider will ship the product within 10 business days after the order is confirmed.

If the shipping takes more than 10 business days, the product page will inform the customer, or the product provider will contact you.

11. Special provisions regarding returns and cancellations:
For products and services sold on this website, we do not accept returns or cancellations after the order is confirmed.
However, if there is a defect in the product or service, we will deal with it in accordance with the provisions of the Terms of Use.
For products or services that have special sales or provision conditions, the conditions will be displayed on the purchase page of each product or service.
`,
  ja: "1.事業者の名称：\n株式会社TODOROKI\n\n2.代表者または通信販売に関する業務の責任者の氏名：\n井上 雅也\n\n3.住所：\n東京都渋谷区東１丁目２５−２　丸橋ビル４F\n\n4.電話番号：\n050-5896-3123\n\n5.メールアドレス：\nsupport@art-scenes.net\n\n6.商品の販売価格・サービスの対価：\n販売している商品は価格を表示しております。\n各商品・サービスのご購入ページをご参照ください。\n\n7.対価以外に必要となる費用：\n送料抜きの価格で表示されており、送料は着払いでお届けしております。\nご注文やお問い合わせの後に、送料についてご連絡いたします。\n配送料にご納得いただけない場合は、すでにご注文されていても決済/発送は行われず、ご注文はキャンセルとなります。\nアート作品は梱包の仕方でサイズが変化したり、保険料の変動など、配送料が複雑なため、送料の自動計算ができないことご了承ください。\n\n銀行振り込みの場合、手数料はお客様にご負担いただきます。\n関税や付加価値税等の税金を含む租税公課が発生する場合、お客さまのご負担になります。\nお客さま指定の配送先に荷物が到着した後に発生する運送料、荷物引取りのために生じた交通費等の諸費用はお客さま負担となります。\nまた、当サイトのページの閲覧、コンテンツ購入、ソフトウェアのダウンロード等に必要となるインターネット接続料金、通信料金は、お客様のご負担となります。\n\n8.代金の支払時期：\n銀行振込：原則として商品のご注文確定後3日以内に指定の口座へお支払いください。ただし、フェア中など入金期限が異なる場合はその旨を商品に記載、またはご連絡いたします。\nクレジットカード：ご利用のカード会社とのご契約に準じます。\n\n9.支払方法：\nクレジット決済\n銀行振込\nその他、高額な商品の場合は、商品提供者よりその他の方法もご案内いたします。\n\n10.商品引渡しまたはサービス提供の時期：\n銀行振り込みの場合、ご入金確認後10営業日以内に商品提供者より発送。\nカード決済の場合、ご注文確定後10営業日以内に商品提供者より発送。\n10営業日を超える場合には、そのように商品ページに記載、もしくは、商品提供者よりご連絡します。\n\n11.返品・キャンセルに関する特約：\n本サイトで販売する商品・サービスについては、ご注文確定後の返品またはキャンセルはお受けいたしません。\nただし、商品・サービスに瑕疵がある場合は、利用規約の定めに従って対応します。\n特別な販売条件または提供条件がある商品またはサービスについては、各商品またはサービスの購入ページにおいて条件を表示します。",

  "zh-Hans": `1. Name of business:
TODOROKI Inc.
2. Name of representative or person in charge of the business:
Inoue Masaya

3. Address:
Marubashi Building 4F, 25-2 Higashi 1-chome, Shibuya-ku, Tokyo

4. Phone number:
050-5896-3123

5. Email address:
support@art-scenes.net

6. Product sales price/service fees:
Prices are displayed for products on sale.
Please refer to the purchase page for each product/service.

7. Costs required additional to the price:
Prices are displayed without including the shipping fees, and shipping fees must be paid upon delivery.
We will contact you about shipping fees after your order or inquiry.
If you are not satisfied with the shipping fees and refuse to pay them, your order will be canceled, and payment/shipping will not be made even if you have already placed an order.
Please note that shipping fees cannot be calculated automatically for all artworks, as the shipping fees vary according to the dimensions of the artwork, the way it is packaged and the fluctuation of insurance premiums, we will thus have to calculate shipping fees manually.

In the case of a payment via bank transfer, the customer will be responsible for any additional fees from the bank.
If the purchase and shipping generate additional taxes, including customs duties and VAT, they will be borne by the customer.
Freight charges incurred after the package reaches the customer's designated delivery address, transportation costs incurred for picking up the package, and other expenses will be the financial responsibility of the customer.
Customers will be responsible for all internet connection fees and communication fees required for browsing the pages of this website, purchasing content, downloading software, etc.

8. Payment period:

Bank transfer: In principle, payment should be made to the specified account within 3 days after the order is confirmed. However, in special circumstances, such as in the occurrence of a purchase during an art fair, we will indicate the payment period on the product or contact you.
Credit card: the payment will take place in accordance with the customer’s contract with the card company used.

9. Accepted payment method:
•	Credit card payment
•	Bank transfer
•	For other high-priced products, the product provider will inform you of other possible payment methods.

10. Delivery period or service provision:

For bank transfer, the product provider will ship the product within 10 business days after payment is confirmed.
For card payment, the product provider will ship the product within 10 business days after the order is confirmed.

If the shipping takes more than 10 business days, the product page will inform the customer, or the product provider will contact you.

11. Special provisions regarding returns and cancellations:
For products and services sold on this website, we do not accept returns or cancellations after the order is confirmed.
However, if there is a defect in the product or service, we will deal with it in accordance with the provisions of the Terms of Use.
For products or services that have special sales or provision conditions, the conditions will be displayed on the purchase page of each product or service.
`,
  "zh-Hant": `1. Name of business:
TODOROKI Inc.
2. Name of representative or person in charge of the business:
Inoue Masaya

3. Address:
Marubashi Building 4F, 25-2 Higashi 1-chome, Shibuya-ku, Tokyo

4. Phone number:
050-5896-3123

5. Email address:
support@art-scenes.net

6. Product sales price/service fees:
Prices are displayed for products on sale.
Please refer to the purchase page for each product/service.

7. Costs required additional to the price:
Prices are displayed without including the shipping fees, and shipping fees must be paid upon delivery.
We will contact you about shipping fees after your order or inquiry.
If you are not satisfied with the shipping fees and refuse to pay them, your order will be canceled, and payment/shipping will not be made even if you have already placed an order.
Please note that shipping fees cannot be calculated automatically for all artworks, as the shipping fees vary according to the dimensions of the artwork, the way it is packaged and the fluctuation of insurance premiums, we will thus have to calculate shipping fees manually.

In the case of a payment via bank transfer, the customer will be responsible for any additional fees from the bank.
If the purchase and shipping generate additional taxes, including customs duties and VAT, they will be borne by the customer.
Freight charges incurred after the package reaches the customer's designated delivery address, transportation costs incurred for picking up the package, and other expenses will be the financial responsibility of the customer.
Customers will be responsible for all internet connection fees and communication fees required for browsing the pages of this website, purchasing content, downloading software, etc.

8. Payment period:

Bank transfer: In principle, payment should be made to the specified account within 3 days after the order is confirmed. However, in special circumstances, such as in the occurrence of a purchase during an art fair, we will indicate the payment period on the product or contact you.
Credit card: the payment will take place in accordance with the customer’s contract with the card company used.

9. Accepted payment method:
•	Credit card payment
•	Bank transfer
•	For other high-priced products, the product provider will inform you of other possible payment methods.

10. Delivery period or service provision:

For bank transfer, the product provider will ship the product within 10 business days after payment is confirmed.
For card payment, the product provider will ship the product within 10 business days after the order is confirmed.

If the shipping takes more than 10 business days, the product page will inform the customer, or the product provider will contact you.

11. Special provisions regarding returns and cancellations:
For products and services sold on this website, we do not accept returns or cancellations after the order is confirmed.
However, if there is a defect in the product or service, we will deal with it in accordance with the provisions of the Terms of Use.
For products or services that have special sales or provision conditions, the conditions will be displayed on the purchase page of each product or service.
`,
};
